import { render, staticRenderFns } from "./technical-information.vue?vue&type=template&id=49680b1f&"
import script from "./technical-information.vue?vue&type=script&lang=js&"
export * from "./technical-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports